<template>
  <BaseItemGroup
    :item="item"
    text
    :prepend-icon="item.icon"
    append-icon="mdi-menu-down"
    class="xyz pl-3"
  />
</template>

<script>
export default {
  name: 'BaseItemSubGroup',

  props: {
    item: {
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        to: undefined,
        children: [],
      }),
    },
  },
}
</script>
